<template>
  <div id="app">
    <!-- <h1 class="h1">英途万相</h1> -->
    <div class="contanier">
      <div style="position: relative" @click="menuClick">
        <p style="text-align: left; font-size: 16px">生成结果</p>
        <div class="img-container">
          <!-- 图片 -->
          <div class="img-box" @contextmenu="contextmenu">
            <div v-if="imgLoading" class="empty">
              <ul class="loading flex">
                <li style="--line-index: 1"></li>
                <li style="--line-index: 2"></li>
                <li style="--line-index: 3"></li>
                <li style="--line-index: 4"></li>
                <li style="--line-index: 5"></li>
                <li style="--line-index: 6"></li>
              </ul>
            </div>
            <template v-else>
              <canvas
                id="canvas"
                v-if="imgShowSrc"
                ref="imgCanvasRef"
                :width="imgWidth"
                :height="imgHeight"
              ></canvas>
              <div v-else class="empty">
                <a-empty :image="simpleImage" description="暂无图片" />
              </div>
            </template>

            <!--  右击事件 -->
            <a-menu
              slot="overlay"
              :style="{
                left: left + 'px',
                top: top + 'px',
                display: isMenuShow ? 'block' : 'none',
              }"
              class="contextMemu"
            >
              <a-menu-item>
                <a @click="savelocalImg()">保存到本地资源</a>
              </a-menu-item>
              <a-menu-item @click="changeToImg(imgShowSrc)">
                <a href="javascript:;">转到图生图</a>
              </a-menu-item>
            </a-menu>
          </div>
          <!-- 显示图片缩略图 -->
          <div class="showImg">
            <img
              :src="item.src"
              alt=""
              v-for="(item, index) in showImgList"
              :key="index"
              @click="showImg(item.src)"
            />
          </div>
        </div>
        <p style="text-align: left; margin-top: 5px">
          右键点击当前图片，显示操作菜单
        </p>

        <a-form class="formShow" layout="horizontal">
          <a-form-item
            class="tagShow"
            label="已选标签："
            :labelCol="{ span: 2 }"
            :colon="false"
          >
            <a-tag
              :color="checkColor[tag.color - 1]"
              closable
              v-for="tag in selectTags"
              :key="tag.value"
              @close="() => tagChange(tag.value, tag.color)"
              >{{ tag.label }}</a-tag
            >

            <span title="一键清除" v-if="selectTags.length" @click="quickClear">
              <delete-icon class="delete-icon"></delete-icon>
            </span>

            <br />

            <div style="position: relative">
              <a-tabs
                v-model="checkKey"
                type="card"
                style="margin: 12px 0; position: relative"
                @change="tabChange"
                :style="{ ...checkfooList }"
              >
                <a-tab-pane
                  v-for="(item, index) in tabOption"
                  :key="index + 1"
                  :tab="item.name"
                >
                  <a-checkbox
                    v-for="checkItem in item.options"
                    :key="checkItem.value"
                    :checked="checkItem.checked"
                    :style="{ '--bgColor': checkColor[checkItem.color - 1] }"
                    @change="(e) => onChange(e, checkItem, item)"
                  >
                    {{ checkItem.label }}
                  </a-checkbox>
                  <!-- 暂无标签 -->
                  <div
                    style="text-align: center; padding-top: 10px"
                    v-if="isSearch && !searchList.length"
                  >
                    暂无查询到的标签
                  </div>
                </a-tab-pane>
              </a-tabs>
              <a-input-search
                v-model="searchValue"
                class="search-box"
                allowClear
                placeholder="请输入标签，按enter键..."
                @search="searchChange"
              />
            </div>
          </a-form-item>
          <a-form-item
            style="position: relative"
            label="生成张数"
            :labelCol="{ span: 2 }"
            :colon="false"
          >
            <a-slider
              style="width: 175px; margin-left: 90px"
              id="test"
              v-model="imgNumber"
              :min="1"
              :max="3"
            />
            <span class="slider">{{ imgNumber }}</span>
          </a-form-item>
          <a-form-item>
            <a-radio-group v-model="modeType">
              <a-radio :value="1">文生图</a-radio>
              <a-radio :value="2">图生图</a-radio>
              <a-radio :value="3">边缘绘制</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-form>

        <div class="imgShow" v-show="modeType == 2">
          <!-- 图生图 左边区域 -->
          <div class="left">
            <div class="uploadbox">
              <canvas
                id="calibrationCanvas"
                v-if="canvasImg"
                ref="canvasRef"
                :width="canvasWidth"
                :height="canvasHeight"
              ></canvas>
              <!--临时的canvas 用来设置橡皮擦-->
              <canvas
                v-if="canvasImg"
                ref="pattCanvasRef"
                :width="canvasWidth"
                :height="canvasHeight"
                style="display: none"
              ></canvas>

              <a-empty
                v-if="!canvasImg"
                :image="simpleImage"
                description="暂无图片"
              />
            </div>
          </div>
          <!-- 图生图 右边区域 -->
          <div class="right">
            <a-form class="formShow" layout="horizontal">
              <a-form-item>
                <a-upload
                  class="upload"
                  name="file"
                  :multiple="true"
                  :showUploadList="false"
                  :before-upload="beforeUpload"
                >
                  <a-button>选择图片</a-button>
                </a-upload>
              </a-form-item>
              <a-form-item
                style="position: relative; display: flex"
                label="局部重绘"
                :labelCol="{ span: 4 }"
                :colon="false"
              >
                <a-checkbox @change="drawSwtich"> 开 / 关 </a-checkbox>
                <div class="drawInfo">
                  <div :class="['text', { checked: isDrawCheck }]">
                    在图片区域涂鸦，选择重绘区域
                  </div>
                  <div :class="['text', { checked: isDrawCheck }]">
                    <span>重绘区域：</span>
                    <a-radio-group
                      :disabled="!isDrawCheck"
                      :options="drawOptions"
                      v-model="drawModeType"
                    />
                  </div>
                  <div :class="['text', { checked: isDrawCheck }]">
                    <span>笔迹大小：</span>
                    <a-slider
                      style="width: 150px; margin-left: 90px"
                      id="test"
                      v-model="penWidth"
                      :min="5"
                      :max="25"
                    />
                    <div class="icon">
                      <span @click="drawType = 'pen'">
                        <pen-icon
                          :style="{
                            color: '#8a8a8a',
                            fontSize: '21px',
                            marginLeft: '10px',
                          }"
                        />
                      </span>
                      <span @click="drawType = 'rub'">
                        <heart-icon
                          :style="{ fontSize: '21px', marginLeft: '12px' }"
                        />
                      </span>
                      <right-icon
                        class="right-icon"
                        :style="{ left: drawType == 'pen' ? '25px' : '60px' }"
                      />
                    </div>
                    <span class="icon"> </span>
                    <span class="clear" @click="clearCanvas">清除</span>
                  </div>
                </div>
              </a-form-item>
              <a-form-item
                style="position: relative; display: flex"
                label="缩放模式"
                :labelCol="{ span: 4 }"
                :colon="false"
              >
                <a-radio-group v-model="sclemode">
                  <a-radio :value="0">拉伸</a-radio>
                  <a-radio :value="1">裁剪</a-radio>
                  <a-radio :value="2">填充</a-radio>
                  <a-radio :value="3">拉伸(潜空间放大)</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item
                label="重绘幅度"
                :labelCol="{ span: 4 }"
                :colon="false"
              >
                <a-slider
                  style="width: 175px; margin-left: 90px"
                  id="test"
                  v-model="canvasNumber"
                  :min="0"
                  :max="1"
                  :step="0.1"
                />
                <span class="slider">{{ canvasNumber }}</span>
              </a-form-item>
            </a-form>
          </div>
        </div>

        <div v-show="modeType == 3">
          <!-- <canvas
            id="calibrationCanvas"
            v-if="canvasImg"
            ref="canvasRef"
            :width="canvasWidth"
            :height="canvasHeight"
          ></canvas> -->
          <a-form class="formShow" layout="horizontal">
            <a-form-item>
              <a-upload
                class="upload"
                name="file"
                :multiple="true"
                :showUploadList="false"
                :before-upload="beforeUpload"
              >
                <a-button>选择图片</a-button>
              </a-upload>
            </a-form-item>
          </a-form>
        </div>

        <div style="text-align: right">
          <a-button class="button" @click="showCanvas">生成</a-button>
        </div>
      </div>
      <canvas
        id="canvas"
        ref="blackCanvasRef"
        :width="canvasWidth"
        :height="canvasHeight"
        style="display: none"
      ></canvas>
    </div>
  </div>
</template>

<script>
import { Empty } from "ant-design-vue";
import { txt2img, img2img, sdSetting } from "@/api/index";
const HeartSvg = {
  template: `<svg t="1700704200230" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4153" width="128" height="128"><path d="M940.862895 326.58917L639.163969 24.890244c-33.187992-33.187992-87.492979-33.185992-120.679971 0L352.550039 190.825203 216.785072 326.58917l-45.254989 45.254989c-8.295998 8.295998-8.296998 21.871995 0 30.169993l15.084996 15.084996L83.137105 520.577123c-33.185992 33.185992-33.185992 87.492979 0 120.67997l241.358941 241.358942c33.185992 33.185992 87.492979 33.185992 120.67997 0l103.477975-103.477975 15.032996 15.032996c8.296998 8.296998 21.873995 8.295998 30.169993 0l44.746989-44.746989c0.175-0.171 0.387-0.284 0.56-0.457l301.698926-301.698926c33.185992-33.184992 33.185992-87.492979 0-120.678971zM548.653991 115.400222c16.592996-16.592996 43.746989-16.592996 60.339985 0l241.358941 241.358941c16.592996 16.592996 16.592996 43.746989 0 60.339985L594.29598 673.053086c-8.295998 8.295998-21.871995 8.296998-30.169993 0l-15.032996-15.032997-241.359941-241.358941-15.136996-15.136996c-8.206998-8.206998-8.228998-21.546995-0.203-29.863993L548.653991 115.400222zM415.006024 792.106057c-16.592996 16.592996-43.746989 16.592996-60.339986 0L173.647083 611.087101c-16.592996-16.592996-16.592996-43.746989 0-60.339985l67.273983-67.273984c3.319999-3.319999 8.749998-3.317999 12.068997 0l229.289944 229.289944c3.317999 3.317999 3.319999 8.748998 0 12.068997l-67.273983 67.273984zM981.332885 981.33301c0 23.466994-19.199995 42.66699-42.666989 42.66699H85.333104c-23.466994 0-42.66699-19.199995-42.666989-42.66699 0-23.466994 19.199995-42.66699 42.666989-42.666989h853.332792c23.466994 0.001 42.66699 19.200995 42.666989 42.666989z" fill="#8692A1" p-id="4154"></path></svg>`,
};
const HeartIcon = {
  template: `
    <a-icon :component="HeartSvg" />
  `,
  data() {
    return {
      HeartSvg,
    };
  },
};
const PenSvg = {
  template: `<svg t="1700705066098" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5320" width="128" height="128"><path d="M79.36 916.48h343.04v51.2H79.36z" fill="" p-id="5321"></path><path d="M550.4 916.48h376.32v51.2H550.4z" fill="" p-id="5322"></path><path d="M629.76 158.72l215.04 215.04L373.76 844.8l-215.04-215.04L629.76 158.72z m0 0" fill="" p-id="5323"></path><path d="M716.8 74.24l215.04 215.04-64 64-215.04-215.04L716.8 74.24z m0 0" fill="" p-id="5324"></path><path d="M138.24 652.8l215.04 215.04L51.2 952.32l87.04-299.52z m0 0" fill="" p-id="5325"></path><path d="M798.72 71.68L931.84 204.8c23.04 23.04 20.48 58.88-2.56 81.92-23.04 23.04-61.44 25.6-81.92 2.56l-133.12-133.12c-23.04-20.48-23.04-58.88 2.56-81.92 23.04-23.04 58.88-25.6 81.92-2.56z m0 0" fill="" p-id="5326"></path></svg>`,
};
const penIcon = {
  template: `
    <a-icon :component="PenSvg" />
  `,
  data() {
    return {
      PenSvg,
    };
  },
};
const rightSvg = {
  template: `<svg t="1700706869061" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11288" width="128" height="128"><path d="M896.969659 16.576036 119.702341 16.576036c-61.317329 0-111.038333 49.665189-111.038333 111.038333l0 777.265288c0 61.265573 49.721004 111.039348 111.038333 111.039348l777.266302 0c61.314284 0 111.036304-49.773775 111.036304-111.039348L1008.004947 127.614369C1008.005962 66.241225 958.283943 16.576036 896.969659 16.576036zM877.124894 340.796156 443.975232 773.888988c-11.680554 11.736369-26.883542 17.734958-42.168729 18.026211-15.069031 1.231989-30.562257-3.90096-42.085514-15.423203L133.583021 550.406799c-20.767234-20.820005-20.767234-54.548493 0-75.368498 20.820005-20.81899 54.59416-20.81899 75.414165 0L389.301916 655.385655l401.179853-401.337149c23.964925-23.853295 62.727926-23.853295 86.643125 0C901.092864 278.126075 901.092864 316.834275 877.124894 340.796156z" fill="#272636" p-id="11289"></path></svg>`,
};
const rightIcon = {
  template: `
    <a-icon :component="rightSvg" />
  `,
  data() {
    return {
      rightSvg,
    };
  },
};

const deleteSvg = {
  template: `<svg t="1701739283466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4233" width="128" height="128"><path d="M799.2 874.4c0 34.4-28.001 62.4-62.4 62.4H287.2c-34.4 0-62.4-28-62.4-62.4V212h574.4v662.4zM349.6 100c0-7.2 5.6-12.8 12.8-12.8h300c7.2 0 12.8 5.6 12.8 12.8v37.6H349.6V100z m636.8 37.6H749.6V100c0-48.001-39.2-87.2-87.2-87.2h-300c-48 0-87.2 39.199-87.2 87.2v37.6H37.6C16.8 137.6 0 154.4 0 175.2s16.8 37.6 37.6 37.6h112v661.6c0 76 61.6 137.6 137.6 137.6h449.6c76 0 137.6-61.6 137.6-137.6V212h112c20.8 0 37.6-16.8 37.6-37.6s-16.8-36.8-37.6-36.8zM512 824c20.8 0 37.6-16.8 37.6-37.6v-400c0-20.8-16.8-37.6-37.6-37.6s-37.6 16.8-37.6 37.6v400c0 20.8 16.8 37.6 37.6 37.6m-175.2 0c20.8 0 37.6-16.8 37.6-37.6v-400c0-20.8-16.8-37.6-37.6-37.6s-37.6 16.8-37.6 37.6v400c0.8 20.8 17.6 37.6 37.6 37.6m350.4 0c20.8 0 37.6-16.8 37.6-37.6v-400c0-20.8-16.8-37.6-37.6-37.6s-37.6 16.8-37.6 37.6v400c0 20.8 16.8 37.6 37.6 37.6" fill="#8A8A8A" p-id="4234"></path></svg>`,
};
const deleteIcon = {
  template: `
    <a-icon :component="deleteSvg" />
  `,
  data() {
    return {
      deleteSvg,
    };
  },
};
export default {
  name: "App",
  components: {
    HeartIcon,
    penIcon,
    rightIcon,
    deleteIcon,
  },
  data() {
    return {
      // 图片容器
      imgWidth: 560,
      imgHeight: 300,
      modeType: 1,
      imgNumber: 1,
      canvasNumber: 0,
      sclemode: 0,
      imgShowSrc: "",
      showImgList: [
        // {
        //   src: "https://img2.baidu.com/it/u=116831269,2430867600&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=313",
        // },
        // {
        //   src: "https://img0.baidu.com/it/u=2779906661,3186016416&fm=253&fmt=auto&app=138&f=JPEG?w=889&h=500",
        // },
        // {
        //   src: "https://img0.baidu.com/it/u=1509373768,3298331737&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1701795600&t=801d47d6a2866d8798317fe11b7397e5",
        // },
      ],
      left: 0,
      top: 0,
      isMenuShow: false,
      drawModeType: 0,
      drawOptions: [
        { label: "涂鸦区域", value: 0 },
        { label: "非涂鸦区域", value: 1 },
      ],
      drawType: "pen", // pen 笔 rub 橡皮檫
      isDrawCheck: false, // 是否开启局部重绘

      // 标签
      selectTags: [],
      checkKey: 1,
      checkfooList: {},
      checkColor: [
        // "#9f20f066",
        // "#ff7b0266",
        // "#e6548066",
        // "#108ee9",
        // "#bdb66b66",
      ], // 标签颜色
      checkboxList: [],
      cloneCheckbox: [], // 备份第一个标签列表
      tabOption: [
        // {
        //   name: "场景",
        //   key: 1,
        //   checkboxList: [],
        //   options: [
        //     { label: "机场", value: "airport", color: 1, checked: false },
        //     {
        //       label: "火车站",
        //       value: "train station",
        //       color: 1,
        //       checked: false,
        //     },
        //     {
        //       label: "咖啡馆",
        //       value: "coffee house",
        //       color: 1,
        //       checked: false,
        //     },
        //     { label: "面包店", value: "bakery", color: 1, checked: false },
        //     { label: "公园", value: "park", color: 1, checked: false },
        //     { label: "铁路", value: "railway", color: 1, checked: false },
        //     {
        //       label: "植物园",
        //       value: "botanical garden",
        //       color: 1,
        //       checked: false,
        //     },
        //   ],
        // },
        // {
        //   name: "环境",
        //   key: 2,
        //   checkboxList: [],
        //   options: [
        //     { label: "大草原", value: "savanna", color: 2, checked: false },
        //     { label: "稻田", value: "rice paddy", color: 2, checked: false },
        //   ],
        // },
        // {
        //   name: "季节",
        //   key: 3,
        //   checkboxList: [],
        //   options: [
        //     { label: "春天", value: "in spring", color: 3, checked: false },
        //     { label: "夏天", value: "in summer", color: 3, checked: false },
        //     { label: "秋天", value: "in autumn", color: 3, checked: false },
        //     { label: "冬天", value: "in winter", color: 3, checked: false },
        //   ],
        // },
        // {
        //   name: "天气",
        //   key: 4,
        //   checkboxList: [],
        //   options: [
        //     { label: "白天", value: "day", color: 4, checked: false },
        //     { label: "黄昏", value: "dusk", color: 4, checked: false },
        //     { label: "夜晚", value: "night", color: 4, checked: false },
        //     { label: "下雨", value: "rain", color: 4, checked: false },
        //     { label: "日落", value: "sunset", color: 4, checked: false },
        //     { label: "多云", value: "cloudy", color: 4, checked: false },
        //     { label: "太阳", value: "sun", color: 4, checked: false },
        //     { label: "月亮", value: "moon", color: 4, checked: false },
        //   ],
        // },
        // {
        //   name: "物品",
        //   key: 5,
        //   checkboxList: [],
        //   options: [
        //     { label: "笔记本", value: "notebook", color: 5, checked: false },
        //     { label: "画笔", value: "paintbrush", color: 5, checked: false },
        //     { label: "铅笔", value: "pencil", color: 5, checked: false },
        //     { label: "书", value: "book", color: 5, checked: false },
        //     { label: "翻开的书", value: "open_book", color: 5, checked: false },
        //     { label: "书摞", value: "book_stack", color: 5, checked: false },
        //     { label: "书架", value: "bookshelf", color: 5, checked: false },
        //     { label: "背包", value: "backpack", color: 5, checked: false },
        //   ],
        // },
      ],

      // canvas
      canvasWidth: 280,
      canvasHeight: 180,
      pattStyle: "",
      penWidth: 15,
      canvasImg: "",

      showimg: "",

      isSearch: false,
      searchValue: "",
      searchList: [], // 搜索列表

      blackurl: "",

      imgLoading: false,

      preImgCanvas: "", // 图生图原图

      createWidth: 1120,
      createHeight: 630,
    };
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  created() {
    this.getSdSetting();
  },
  watch: {
    drawType(val) {
      this.setDrawType(val);
    },
    isDrawCheck() {
      if (!this.canvasImg) return;
      this.initDrawCheck();
    },
    searchValue(val) {
      if (val === "") {
        this.tabOption[0].options = this.cloneCheckbox;
        this.isSearch = false;

        this.isDrawCheck = false;
      }
    },
  },
  methods: {
    getSdSetting() {
      sdSetting().then((res) => {
        const prompt = JSON.parse(res.data).prompt;
        this.checkColor = [];
        this.tabOption = [];
        prompt.forEach((item, index) => {
          let obj = {};
          this.checkColor.push(item.color);
          item.tags.map((v) => {
            v.label = v.name;
            v.color = index + 1;
            v.checked = false;
          });
          obj.name = item.category;
          obj.color = item.color;
          obj.key = index + 1;
          obj.checkboxList = [];
          obj.options = item.tags;
          this.tabOption.push(obj);
        });
        this.checkfooList = {
          "--bgColors": this.checkColor[0],
          "--bgColors2": this.checkColor[1],
          "--bgColors3": this.checkColor[2],
          "--bgColors4": this.checkColor[3],
          "--bgColors5": this.checkColor[4],
          "--bgColors6": this.checkColor[5],
          "--bgColors7": this.checkColor[6],
          "--bgColors8": this.checkColor[7],
        };

        this.cloneCheckbox = this.tabOption[0].options;
      });
    },
    // 操作标签栏
    onChange(e, checkedValues, row) {
      checkedValues.checked = e.target.checked;

      if (e.target.checked) {
        // 选中标签
        this.selectTags.push(checkedValues);
        row.checkboxList.push(checkedValues);
      } else {
        // 取消选中标签
        const index = this.selectTags.findIndex(
          (v) => v.checked == e.target.checked && v.value == checkedValues.value
        );
        const vindex = row.checkboxList.findIndex(
          (v) => v.checked == e.target.checked && v.value == checkedValues.value
        );
        this.selectTags.splice(index, 1);
        row.checkboxList.splice(vindex, 1);
      }
    },
    // 操作已选标签
    tagChange(value, color) {
      const index = this.selectTags.findIndex((v) => v.value == value);
      this.selectTags.splice(index, 1);

      const checkindex = this.tabOption[color - 1].checkboxList.findIndex(
        (v) => v == value
      );

      this.tabOption[color - 1].checkboxList.splice(checkindex, 1);

      this.tabOption.forEach((item) => {
        if (color == item.key) {
          const index = item.checkboxList.findIndex((v) => v.value == value);
          item.checkboxList.splice(index, 1);
          const checkindex = item.options.findIndex((v) => v.value == value);
          item.options[checkindex].checked = false;
        }
      });
    },
    // 更改鼠标指针
    setDrawType(val) {
      // 选择要更改鼠标指针的元素
      var element = document.querySelector("#calibrationCanvas");
      // 将鼠标指针更改为十字
      element.style.cursor = val == "pen" ? "crosshair" : "pointer";
    },
    showImg(src) {
      this.imgShowSrc = src;
      // 创建img
      const img = new Image();
      img.src = src;
      /* 解决跨域问题 */
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        const canvasCtx = this.$refs.imgCanvasRef.getContext("2d");
        canvasCtx.drawImage(img, 0, 0, this.imgWidth, this.imgHeight);
      };
    },
    // 转到图生图
    changeToImg(src) {
      this.canvasImg = src;
      this.preImgCanvas = src;
      this.modeType = 2;

      this.$nextTick(() => {
        this.clearCanvas();
        this.initDrawImg(src);
      });
    },
    initDrawImg(src) {
      // 创建img
      const img = new Image();
      img.src = src;
      img.setAttribute("crossOrigin", "anonymous");
      // 画布
      img.onload = () => {
        const canvasCtx = this.$refs.canvasRef.getContext("2d");
        const pattCanvasCtx = this.$refs.pattCanvasRef.getContext("2d");
        const blackCanvasCtx = this.$refs.blackCanvasRef.getContext("2d");

        canvasCtx.drawImage(img, 0, 0, this.canvasWidth, this.canvasHeight);
        pattCanvasCtx.drawImage(img, 0, 0, this.canvasWidth, this.canvasHeight);
        blackCanvasCtx.fillStyle = "#000";
        blackCanvasCtx.fillRect(0, 0, this.canvasWidth, this.canvasHeight);

        this.initDrawCheck();
      };
    },
    // 开启绘图
    initDrawCheck() {
      const arr = ["canvasRef", "blackCanvasRef"];
      if (this.isDrawCheck) {
        // 开启局部绘图
        arr.forEach((item) => {
          this.$refs[item].addEventListener("mousedown", this.mouseHandler);
        });
        // 更改绘图图标
        this.setDrawType(this.drawType);
      } else {
        arr.forEach((item) => {
          this.$refs[item].removeEventListener("mousedown", this.mouseHandler);
        });
      }
    },
    // 操作canvas绘图
    mouseHandler(e) {
      const x = e.offsetX - 20;
      const y = e.offsetY - 10;
      const canvasCtx = this.$refs.canvasRef.getContext("2d");
      const pattCanvasCtx = this.$refs.pattCanvasRef.getContext("2d");
      const blackCanvasCtx = this.$refs.blackCanvasRef.getContext("2d");
      const refArr = ["canvasRef", "blackCanvasRef"]; // 原图和轨迹图

      canvasCtx.globalAlpha = 0.1; //设置全局透明度
      canvasCtx.imgWidth = 200;
      canvasCtx.imgHeight = 200;
      // canvasCtx.globalCompositeOperation='destination-atop';
      switch (e.type) {
        case "mousedown":
          canvasCtx.beginPath();
          canvasCtx.moveTo(x, y);
          canvasCtx.lineWidth = this.penWidth;
          canvasCtx.strokeStyle =
            this.drawType == "rub"
              ? this.pattStyle
              : "rgba(255, 255, 255, 0.02)";

          blackCanvasCtx.beginPath();
          blackCanvasCtx.moveTo(x, y);
          blackCanvasCtx.lineWidth = this.penWidth;
          blackCanvasCtx.strokeStyle =
            this.drawType == "rub" ? "#000" : "rgba(255, 255, 255)";

          refArr.forEach((item) => {
            this.$refs[item].addEventListener("mousemove", this.mouseHandler);
            this.$refs[item].addEventListener("mouseup", this.mouseHandler);
          });
          break;
        case "mousemove":
          canvasCtx.lineTo(x, y);
          canvasCtx.stroke();

          blackCanvasCtx.lineTo(x, y);
          blackCanvasCtx.stroke();

          break;
        case "mouseup":
          canvasCtx.closePath();
          blackCanvasCtx.closePath();

          this.pattStyle = pattCanvasCtx.createPattern(
            this.$refs.pattCanvasRef,
            "no-repeat"
          );

          refArr.forEach((item) => {
            this.$refs[item].removeEventListener(
              "mousemove",
              this.mouseHandler
            );
            this.$refs[item].removeEventListener("mouseup", this.mouseHandler);
          });

          break;
      }
    },
    showCanvas() {
      if (!this.selectTags.length) {
        this.$message.info("请选择标签");
        return;
      }

      this.imgLoading = true;

      this.showImgList = [];

      // 标签
      let tagStr = this.selectTags.map((v) => v.value).toString();

      // 存储数据的时间戳id
      const timestamp = Math.round(new Date());

      if (this.modeType == 1) {
        let formdata = new FormData();
        const obj = {
          task_id: timestamp,
          prompt: tagStr, // 标签
          n_iter: this.imgNumber, // 张数
          width: this.createWidth,
          height: this.createHeight,
          negative_prompt:
            "nsfw,blurry,bad anatomy,low quality,worst quality,normal quality,disfigured,text,watermark,lowres,cropped,bad proportions,painting,comic,unreal,sketch,",
        };
        for (let item in obj) {
          formdata.append(item, obj[item]);
        }
        txt2img(formdata)
          .then((res) => {
            if (res.data?.images) {
              res.data?.images.forEach((item) => {
                this.showImgList.push({
                  src: `data:image/png;base64,${item}`,
                });
              });
              const imageSrc = `data:image/png;base64,${res.data.images[0]}`;
              this.imgShowSrc = imageSrc;
              let image = new Image();
              image.src = imageSrc;
              /* 解决跨域问题 */
              image.setAttribute("crossOrigin", "anonymous");
              image.onload = () => {
                const canvasCtx = this.$refs.imgCanvasRef.getContext("2d");
                canvasCtx.drawImage(image, 0, 0, this.imgWidth, this.imgHeight);
              };
              this.imgLoading = false;
            } else {
              this.imgLoading = false;
            }
          })
          .catch(() => {
            this.imgLoading = false;
          });
      } else {
        const canvasImg = this.handleImgCanvas();
        this.preImgCanvas = this.preImgCanvas.replace(
          "data:image/png;base64,",
          ""
        );
        const imgarr = [this.preImgCanvas];

        let formdata = new FormData();
        const obj = {
          task_id: timestamp,
          prompt: tagStr, // 标签
          n_iter: this.imgNumber, // 张数
          width: this.createWidth,
          height: this.createHeight,
          init_images: imgarr,
          include_init_images: true,
          resize_mode: this.sclemode,
          denoising_strength: this.canvasNumber,
          mask: canvasImg, // 轨迹图
          inpainting_mask_invert: this.drawModeType, // 重绘模式（区域）
          inpainting_fill: 1,
          inpaint_full_res: false,
          mask_blur: 5,
          sampler_name: "DPM++ 2M Karras",
          seed: -1,
          batch_size: 1,
          steps: 25,
          cfg_scale: 8,
          override_settings: {
            sd_model_checkpoint: "sd_xl_refiner_1.0",
          },
          negative_prompt:
            "nsfw,blurry,bad anatomy,low quality,worst quality,normal quality,disfigured,text,watermark,lowres,cropped,bad proportions,painting,comic,unreal,sketch,",
        };
        for (let item in obj) {
          formdata.append(item, obj[item]);
        }
        img2img()
          .then((res) => {
            if (res.data?.images) {
              res.data?.images.forEach((item) => {
                this.showImgList.push({
                  src: `data:image/png;base64,${item}`,
                });
              });
              const imageSrc = `data:image/png;base64,${res.data.images[0]}`;
              this.imgShowSrc = imageSrc;
              let image = new Image();
              image.src = imageSrc;
              /* 解决跨域问题 */
              image.setAttribute("crossOrigin", "anonymous");
              image.onload = () => {
                const canvasCtx = this.$refs.imgCanvasRef.getContext("2d");
                canvasCtx.drawImage(image, 0, 0, this.imgWidth, this.imgHeight);
              };
              this.imgLoading = false;
            } else {
              this.imgLoading = false;
              this.$message.success("baocuo");
            }
          })
          .catch(() => {
            this.imgLoading = false;
          });
      }
    },
    handleImgCanvas() {
      const blackCanvasCtx = this.$refs.blackCanvasRef.getContext("2d");
      var imgdata = blackCanvasCtx.getImageData(
        0,
        0,
        this.canvasWidth,
        this.canvasHeight
      );
      var canvas = document.createElement("canvas");
      canvas.width = this.canvasWidth;
      canvas.height = this.canvasHeight;
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "#000";
      ctx.putImageData(imgdata, 0, 0);
      var dataUrl = canvas
        .toDataURL("image/png")
        .replace("data: image/png;base64,", "");
      this.blackurl = dataUrl;
      return dataUrl || "";
    },
    contextmenu(e) {
      if (!this.imgShowSrc) return;
      this.left = e.offsetX;
      this.top = e.offsetY;
      e.returnValue = false;
      this.isMenuShow = true;
      return false;
    },
    menuClick() {
      this.isMenuShow = false;
    },
    // 重绘开关
    drawSwtich(e) {
      this.isDrawCheck = e.target.checked;
    },
    // 清除绘画
    clearCanvas() {
      if (!this.$refs?.canvasRef?.getContext("2d")) return;
      const canvasCtx = this.$refs.canvasRef?.getContext("2d");
      const pattCanvasCtx = this.$refs.pattCanvasRef?.getContext("2d");
      const blackCanvasCtx = this.$refs.blackCanvasRef.getContext("2d");
      // 清空画布
      canvasCtx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      pattCanvasCtx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      blackCanvasCtx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      this.$nextTick(() => {
        canvasCtx.globalAlpha = 1; // 设置全局透明度
        this.initDrawImg(this.canvasImg);
      });
    },
    // 保存到本地资源
    savelocalImg() {
      const image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        const event = new MouseEvent("click");
        a.download = name || "photo";
        a.href = url;
        a.dispatchEvent(event);
      };

      image.src = this.imgShowSrc;
    },
    // 一键清除
    quickClear() {
      this.selectTags = [];
      this.tabOption.map((v) => (v.checkboxList = []));
      this.tabOption.forEach((item) => {
        item.checkboxList = [];
        item.options.map((v) => (v.checked = false));
      });
    },
    // 搜索标签
    searchChange(val) {
      if (val === "") return;
      this.isSearch = val !== "";
      this.searchList = [];
      this.tabOption.forEach((item) => {
        item.options.map((v) => {
          if (val !== "" && v.label.indexOf(val) !== -1) {
            this.searchList.push(v);
          }
        });
      });
      this.tabOption[0].options = this.searchList;
      this.checkKey = 1;
    },
    tabChange() {
      this.isSearch = false;
      if (this.checkKey == 1) {
        this.tabOption[0].options = this.cloneCheckbox;
      }
    },
    beforeUpload(file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.canvasImg = reader.result;
        this.preImgCanvas = reader.result;
        this.clearCanvas();
        this.initDrawImg(reader.result);
      };
      reader.readAsDataURL(file);

      return false;
    },
  },
};
</script>

<style scoped lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.h1 {
  text-align: center;
  font-weight: 500;
  font-size: 30px;
  padding: 10px;
}
.contanier {
  color: #2c3e50;
  width: 820px;
  margin: 0 auto;
  background: #4d4c4c;
  color: #fff;
  padding: 15px;
}
::v-deep .ant-menu-item-selected > a {
  color: rgba(0, 0, 0, 0.65);
  background: #fff;
}
::v-deep .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background-color: transparent;
}
::v-deep .ant-checkbox-wrapper {
  color: #fff;
  margin-right: 8px;
}
::v-deep .ant-tabs-bar {
  margin: 0;
}
::v-deep .ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-right: 8px;
  margin-left: 0;
}
::v-deep .ant-tabs-tabpane.ant-tabs-tabpane-active {
  border: 1px solid #fff;
  border-top: none;
  padding: 0px 10px 10px;
  color: #fff;
}

::v-deep .tagShow .ant-tabs-tabpane .ant-checkbox-wrapper {
  border: 1px solid #fff;
  padding: 2px 0 2px 7px;
  background: var(--bgColor);
}
/* tab */
::v-deep .ant-tabs-nav-container {
  height: 30px !important;
}
::v-deep .ant-tabs-tab {
  height: 30px !important;
  line-height: 28px !important;
}
$fooList: var(--bgColors) var(--bgColors2) var(--bgColors3) var(--bgColors4)
  var(--bgColors5) var(--bgColors6) var(--bgColors7) var(--bgColors8)
  var(--bgColors9) var(--bgColors10);
::v-deep .tagShow {
  @for $i from 1 through length($fooList) {
    .ant-tabs-tab:nth-child(#{$i}) {
      background: nth($fooList, $i) !important;
      color: #fff !important;
    }
  }
}
// ::v-deep .tagShow .ant-tabs-tab:nth-child(1) {
//   background: #9f20f066 !important;
//   color: #fff !important;
// }
// ::v-deep .tagShow .ant-tabs-tab:nth-child(2) {
//   background: #ff7b0266 !important;
//   color: #fff !important;
// }
// ::v-deep .tagShow .ant-tabs-tab:nth-child(3) {
//   background: #e6548066 !important;
//   color: #fff !important;
// }
// ::v-deep .tagShow .ant-tabs-tab:nth-child(4) {
//   background: #108ee9 !important;
//   color: #fff !important;
// }
// ::v-deep .tagShow .ant-tabs-tab:nth-child(5) {
//   background: #bdb66b66 !important;
//   color: #fff !important;
// }
/* check label */
::v-deep .ant-tabs-tabpane label {
  margin-top: 10px;
}
::v-deep .ant-tabs-tabpane label:last-child {
  margin-top: 10px !important;
}
/* 打勾选中样式 */
::v-deep .ant-tabs-tabpane .ant-checkbox-checked .ant-checkbox-inner {
  background-color: var(--bgColor);
  border-color: var(--bgColor);
}
::v-deep .drawInfo .ant-slider {
  display: inline-block;
  margin: 0px;
  margin-left: 10px !important;
  vertical-align: middle;
}
::v-deep .ant-empty {
  display: flex;
  width: 260px !important;
  height: 180px !important;
  margin: auto !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .ant-empty-normal {
  margin: 0;
}
::v-deep .ant-empty-description {
  color: #fff;
}
::v-deep .ant-form-item {
  margin-bottom: 0px;
}
::v-deep .ant-form-item-label label {
  color: #fff !important;
}
::v-deep .ant-form-item-children {
  position: relative;
}
::v-deep .formShow .ant-radio-wrapper span {
  color: #fff !important;
}
::v-deep .ant-input-affix-wrapper .ant-input-suffix {
  top: 42%;
}
::v-deep .ant-spin-dot {
  font-size: 26px;
}
::v-deep .ant-spin-nested-loading > div > .ant-spin .ant-spin-text {
  padding-top: 15px;
  padding-left: 15px;
  text-shadow: none;
}
::v-deep .ant-progress-line {
  width: 60%;
}
::v-deep .ant-progress-text {
  color: #fff !important;
}

/* 图片容器 */
.img-container {
  border: 1px solid #fff;
  text-align: center;
  min-height: 440px;
}
.img-box {
  width: 560px;
  height: 300px;
  position: relative;
  margin: 0 auto;
  border: 1px solid #fff;
  border-top: none;
  /* display: flex; */
}

.img-box .empty {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.showImg {
  display: flex;
  align-content: center;
  justify-content: center;
  margin: 16px auto;
}
.showImg img {
  width: 180px;
  height: 110px;
  margin: 0 5px;
  cursor: pointer;
  transition: transform 0.5s;
  padding: 10px;
}

.showImg img:hover {
  background: rgb(41, 141, 187);
  opacity: 0.8;
}

.formShow {
  margin-bottom: 20px;
}

.formShow .slider {
  right: 480px;
}

.contextMemu {
  position: absolute;
  background: #fff;
  left: 0;
  top: 0;
}

.selectShow {
  border: 1px solid #fff;
  min-height: 360px;
  text-align: left;
  color: #fff;
  padding: 10px 0;
}
.slider {
  position: absolute;
  top: -13px;
  color: #fff;
  font-size: 16px;
}
.imgShow .right .slider {
  right: 125px;
}
/* .button {
  position: absolute;
  bottom: -20px;
  right: 0;
} */
.imgShow .slider {
  right: 45px;
}
.textShow {
  position: relative;
}
.textShow .button {
  position: absolute;
  right: 16px;
}
.imgShow {
  display: flex;
  margin-bottom: 15px;
}
.imgShow .left {
  width: 44%;
  /* border-right: 1px solid #fff; */
}
.imgShow .left .uploadbox {
  display: flex;
  height: 230px;
  border: 1px solid #fff;
  padding: 12px;
}
.imgShow .left .uploadbox img {
  width: 266px;
  height: 160px;
}
.imgShow .left .uploadbox .upload {
  margin-left: 10px;
}
.imgShow .right {
  width: 55%;
  margin-left: 20px;
}
.drawInfo {
  color: #fff;
  font-size: 13px;
  line-height: 28px;
}
.drawInfo .text {
  color: #807d7d;
}
.drawInfo .checked {
  color: #fff;
}
.drawInfo .anticon {
  cursor: pointer;
}
.drawInfo .icon {
  position: relative;
  display: inline-block;
}
.drawInfo .icon .right-icon {
  position: absolute;
  left: 25px;
  top: 12px;
  background: #fff;
}
.drawInfo .clear {
  display: inline-block;
  font-size: 16px;
  width: 50px;
  height: 26px;
  font-size: 14px;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  border-color: #d9d9d9;
  line-height: 29px;
  text-align: center;
  margin-left: 13px;
  cursor: pointer;
}
.tagShow {
  position: relative;
}
.delete-icon {
  font-size: 18px;
  vertical-align: middle;
  cursor: pointer;
}
.search-box {
  width: 250px;
  height: 39px;
  position: absolute !important;
  /* background: red; */
  top: -6px !important;
  right: 0;
}

/*使用csS变量*/
.flex {
  display: flex;
  list-style: none;
  /* 设定li元素横向排列*/
}
.loading {
  width: 140px;
}

.loading > li {
  /* 我们在每一个li元素的行内元素都定义了一个css变量--line-index大小不同 */
  /*此时定一个动面延退的变量--time 经过计算calc */
  --time: calc((var(--line-index) - 1) * 200ms);
  border-radius: 3px;
  width: 6px;
  height: 30px;
  background-color: #f66;
  /* 动面都是一个动画，但是开始的时间不同，就显示出这样的效果了*/
  animation: beat 1.5s ease-in-out var(--time) infinite;
}
.loading > li + li {
  margin-left: 5px;
}

@keyframes beat {
  0%,
  100% {
    transform: scaleY(1);
  }
  50% {
    transform: scaleY(0.5);
  }
}
</style>
